import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker.js';
import VueMeta from 'vue-meta';
import router from './router';
import store from './store';
import PrimeVue from 'primevue/config';
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.use(VueMeta);
import 'primevue/resources/themes/saga-blue/theme.css'; // Das Theme
import 'primevue/resources/primevue.min.css'; // Basis-CSS
import 'primeicons/primeicons.css'; // Icons
Vue.use(PrimeVue);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAEEH53yxdezxl76pAajIcsM56ducvz0mA',
        libraries: 'places',
    },
    installComponents: true
});
console.log('VueGoogleMaps', VueGoogleMaps);
console.log("Vue Version " + Vue.version);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
